import * as Types from './types';

const handleGetUserData = (state, action) => ({
  ...state,
  currentUser: action.payload
});

const handleUserExists = (state, action) => ({
  ...state,
  userExists: action.payload
});

const handleLoadUserProfile = (state, action) => ({
  ...state,
  authenticated: true,
  profile: action.payload
});

const handleAcessoCidadaoPermitido = (state, action) => ({
  ...state,
  acessoCidadaoPermitido: action.payload,
  acessoCidadaoPermitidoCarregado: true
});

const handleEnvioDocumentosHabilitado = (state, action) => ({
  ...state,
  envioDocumentosHabilitado: action.payload
});

const handlers = {
  [Types.GET_USER_DATA]: handleGetUserData,
  [Types.USER_EXISTS_VALIDATION]: handleUserExists,
  [Types.LOAD_USER_PROFILE]: handleLoadUserProfile,
  [Types.ACESSO_CIDADAO_PERMITIDO_VALIDATION]: handleAcessoCidadaoPermitido,
  [Types.ENVIO_DOCUMENTOS_HABILITADO_VALIDATION]: handleEnvioDocumentosHabilitado
};

const initialState = {
  userExists: {},
  currentUser: {},
  authenticated: false,
  profile: {},
  acessoCidadaoPermitido: true,
  acessoCidadaoPermitidoCarregado: false,
  envioDocumentosHabilitado: false
};

const UserReducer = (state = initialState, action) => {
  const handler = handlers[action.type];
  return handler ? handler(state, action) : state;
};

export default UserReducer;
